<script>
import { uiMethods, uiComputed } from '@state/helpers'

export default {
  computed: {
    ...uiComputed,
  },
  methods: {
    ...uiMethods,
  },
}
</script>

<template>
  <div
    class="bg-gray-800 text-center text-lg text-white py-4 block lg:hidden flex flex-column"
  >
    <font-awesome-icon
      :icon="['fas', 'bars']"
      class="mx-4 text-2xl cursor-pointer"
      :class="{
        'opacity-50': !sidebarExpanded,
      }"
      @click="toggleSidebar"
    />
    <div class="text-center flex-1 pr-4"> Koordinavimo sistema </div>
  </div>
</template>
